import { render, staticRenderFns } from "./Elektrogeraete.vue?vue&type=template&id=8afc30de"
import script from "./Elektrogeraete.vue?vue&type=script&lang=js"
export * from "./Elektrogeraete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports